import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.rtl.min.css';
import 'bootstrap-icons/font/bootstrap-icons.min.css';
import {ThemeProvider} from "react-bootstrap";
import './assets/css/fontiran.css';
import './assets/css/app.css';

import App from './App';
import Human from "./human";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ThemeProvider dir="rtl">
        <App/>
    </ThemeProvider>
);
